import React, { useMemo } from 'react'
import * as jsyaml from 'js-yaml'
import { Workflow, WorkflowConfig } from '../../lib/types'
import auth from '../../lib/auth'
import './workflow-card.css'
import { Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import { workflowStatusOptions } from '../util'

type Props = {
    workflow: Workflow
}

export default function WorkflowCard(props: Props) {
    const { workflow } = props
    const { statusId } = workflow
    let config = useMemo(() => {
        return jsyaml.load(workflow.config) as WorkflowConfig
    }, [workflow])

    let isAdmin = auth.checkRole('admin', 'workflowAdmin')
    let isLead = auth.checkRole('lead')
    let isMember = workflow.valid && (isAdmin || !!workflow.users.some(item => item.id === Number(auth.user?.sub)))
    let numAccounts = workflow.valid ? workflow.users.length : 0
    let ended = workflow.valid && config.end && new Date(config.end) < new Date()

    return (
        <div className='workflow-card'>
            <div className='w-2/3'>
                <div className='mb-4'>
                    <span className='text-lg font-medium mr-4'>{workflow.name}</span>

                    {!workflow.valid && (
                        <span className='bg-red-500 text-white text-sm px-2 py-1 rounded-full'>
                            Invalid Config
                        </span>
                    )}
                    {ended && (
                        <span className='bg-yellow-400 text-gray-600 text-sm px-2 py-1 rounded-full'>
                            Ended
                        </span>
                    )}
                </div>
                {config.description && (
                    <ReactMarkdown className='my-5'>{config.description}</ReactMarkdown>
                )}
                <div>
                    {(workflow.valid || isMember) && !ended ? (
                        <Link className='button white' to={'/workflows/' + workflow.id}>
                            Access
                        </Link>
                    ) : (
                        <button className='white' disabled>
                            Access
                        </button>
                    )}
                    {(isAdmin || (isLead && workflow.statusId === 1)) && (
                        <Link className='button blue ml-2' to={`/workflows/${workflow.id}/edit`}>
                            Edit
                        </Link>
                    )}
                </div>
            </div>

            {workflow.valid && (
                <div className='ml-16 text-sm border-l-2 pl-5'>
                    <div>
                        <i className='lni lni-warning' /> {workflowStatusOptions[statusId]?.label}
                    </div>
                    <div className='mb-2'>
                        <i className='lni lni-layers' /> {config.steps.length} Step Process
                    </div>
                    <div className='mb-2'>
                        <i className='lni lni-user' /> {numAccounts} Participant
                        {numAccounts !== 1 && 's'}
                    </div>
                    <div>
                        <i className='lni lni-calendar' /> {config.start.toLocaleDateString()}{' '}
                        {config.end && ' – ' + config.end.toLocaleDateString()}
                    </div>
                </div>
            )}
        </div>
    )
}
